import React from 'react';
import { useParams } from 'react-router';

import AdminBrowseHomeEditPage from 'app/components/admin/browse/home/AdminBrowseHomeEditPage';

export function AdminBrowseHomeEditPageRoute() {
  const { localeCode } = useParams();

  return <AdminBrowseHomeEditPage browseHomePageId={null} localeCode={localeCode} />;
}

export default AdminBrowseHomeEditPageRoute;
